import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useMemo } from "preact/hooks";
import { currencyFormat } from "../../util/Formatter";
const PlanInputRadio = ({ selected, value, onInput }) => {
    const handleInput = () => {
        onInput(value);
    };
    const checked = useMemo(() => {
        return value.id === selected;
    }, [selected, value]);
    return (_jsx("li", { children: _jsxs("label", Object.assign({ class: "radio" }, { children: [_jsx("input", { type: "radio", name: "selectedPlan", class: "mr1", onInput: handleInput, checked: checked }, void 0), value.name, "(", currencyFormat(value.price), " / ", value.requirementMinute, "\u5206)"] }), void 0) }, void 0));
};
export default PlanInputRadio;
